<template>
  <div id="review-preview-actions" :class="index>1?'position-relative':''">
    <div v-if="!isServerData">
      <div class="left-div" :class="actions.type=='AND' || operators[actions.type] == 'AND' ?'isAnd':'isOr'"></div>   
      <div v-for="(item,indexItem) in actions.conditions" :key="indexItem">
        <!-- v-if="!isServerData"  -->
        <p :class="[indexItem>0?'mt-3':'']" class="review-preview-actions__text">
          <span v-if="item.metric.value && item.range.value && item.operator.value && item.value && item.results && item.results.length" v-for="(camp,indexCamp) in item.results" :key="indexCamp" :class="indexCamp > 0 ? 'mt-2' : ''" class="display-block">
            {{
              item.range.value !== 'lifetime' ? item.level.toUpperCase()+' ('+camp.id+') '+item.metric.name+` (${camp.value} ${showValueType(item)})`+`${item.range.value == 'today' ? '  ' : ' in the '}`+item.range.name+' is '+math_operators[item.operator.value].replace(/_/,' ')+' '+item.value+' '+showValueType(item)  : item.level.toUpperCase()+' ('+camp.id+') '+item.metric.name+`( ${camp.value} ${showValueType(item)})`+' '+math_operators[item.operator.value].replace(/_/,' ')+' '+item.value+' '+showValueType(item)
            }}

            <!-- <span class="ml-2 text-secondary font-weight-normal" v-if="indexCamp < item.results.length-1">and</span> -->
          </span>

          <span v-if="item.metric.value && item.range.value && item.operator.value && item.value && !(item.results && item.results.length)">
            {{
              item.range.value !== 'lifetime' ? item.metric.name+`${item.range.value == 'today' ? '  ' : ' in the '}`+item.range.name+' is '+math_operators[item.operator.value].replace(/_/,' ')+' '+item.value+' '+showValueType(item) : item.metric.name+' '+math_operators[item.operator.value].replace(/_/,' ')+' '+item.value+' '+showValueType(item)
            }}
          </span>
          <span class="ml-2 text-secondary font-weight-normal my-2" v-if="(actions.conditions[indexItem+1] || actions.groups.length) && actions.type">{{operators[actions.type].toLowerCase()}}</span>
        </p>
      </div>  
      <!-- menu_chart.list -->
      <div v-if="actions.groups.length">
        <div v-for="(child,indexChild) in actions.groups" :key="indexChild" class="mt-3">
          <p v-if="indexChild > 0" class="text-secondary display-block mb-3 w-100">or</p>
          <ReviewPreviewActions :isServerData="isServerData" :index="index+1" :actions="child" ></ReviewPreviewActions>
        </div>
      </div>
    </div>
    <div v-else>
      <div :class="checkEval(actions.equation)?'success':'error'" class="left-div"></div>
      <p class="review-preview-actions__text">

        <span v-if="actions.metric.value && ( actions.range || actions.range.value) && (actions.operator || actions.operator.value) && actions.value">
          <!-- {{
            actions.range.value !== 'lifetime' ? $t('menu_chart.list.'+actions.metric.value)+' in the '+$t('new_automated_rule.new_automated_rule_tabs.'+actions.range.value).toLowerCase()+' '+$t('new_automated_rule.operators.'+math_operators[actions.operator.value])+' '+actions.value+' '+showValueType(actions) : $t('menu_chart.list.'+actions.metric.value)+' '+$t('new_automated_rule.operators.'+math_operators[actions.operator.value])+' '+actions.value+' '+showValueType(actions)
          }} -->
          {{actions.metric.value+' : '+formatEquation(actions.equation)}}
        </span>
        <!-- (actions.conditions[indexItem+1] || actions.groups.length) &&  -->
        <!-- <span class="ml-2 text-secondary font-weight-normal" v-if="actions.type">{{operators[actions.type].toLowerCase()}}</span> -->

      </p>
    </div>
  </div>
</template>

<script>
import ReviewPreviewActions from './ReviewPreviewActions.vue'
export default {
  name: 'ReviewPreviewActions',
  props:{
      actions:{type:Object,default(){return {} }},
      index:{type:Number,default:1},
      isServerData:{type:Boolean,default:false}
  },
  components: {
    ReviewPreviewActions
  },
  mounted(){
    
  },
  data(){
    return{
      operators:{
        "&&":"AND",
        "||":"OR",
        "AND":"AND",
        "OR":"OR"
      },
      math_operators:{
        ">":"greater_than",
        "<":"less_than",
        ">=":"greater_than_or_equal",
        "<=":"less_than_or_equal",
        "=":"equal",
        "==":"equal"
      }
    };
  },
  watch:{
      
  },
  computed:{
    
  },
  methods:{
    showValueType(item){
      if(item.value_type){
          return item.value_type
      }
      return ""
    },
    checkEval(value){
      return eval(value)
    },
    formatEquation(equation){
      let splited = equation ? equation.split(this.actions.operator.value) : ""
      // console.log("spliuted",splited)
      if(splited.length){
        let final = null
        for(let i=0;i<splited.length;i++){
          splited[i] = splited[i].trim()
          splited[i] = splited[i] +" "+this.showValueType(this.actions)
        }
        final = splited.join(' '+this.actions.operator.value+' ')
        return final
      }
      else{
        return equation
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>